import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/shopLabFeature/banner.jpg'
import navColor from '../../assets/shopLabFeature/nav/color.jpg'

import far1 from '../../assets/shopLabFeature/nav/far1.png'
import far1_active from '../../assets/shopLabFeature/nav/far1_active.png'
import far2 from '../../assets/shopLabFeature/nav/far2.png'
import far2_active from '../../assets/shopLabFeature/nav/far2_active.png'

import son1 from '../../assets/shopLabFeature/nav/son1.png'
import son1_active from '../../assets/shopLabFeature/nav/son1_active.png'
import son2 from '../../assets/shopLabFeature/nav/son2.png'
import son2_active from '../../assets/shopLabFeature/nav/son2_active.png'
import son3 from '../../assets/shopLabFeature/nav/son3.png'
import son3_active from '../../assets/shopLabFeature/nav/son3_active.png'
import son4 from '../../assets/shopLabFeature/nav/son4.png'
import son4_active from '../../assets/shopLabFeature/nav/son4_active.png'
import son5 from '../../assets/shopLabFeature/nav/son5.png'
import son5_active from '../../assets/shopLabFeature/nav/son5_active.png'
import son6 from '../../assets/shopLabFeature/nav/son6.png'
import son6_active from '../../assets/shopLabFeature/nav/son6_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(83),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(83),
    backgroundImage: 'none',
  },
  navCtnFixed: {
    height: calcRemFn(83),
    backgroundImage: 'none',
  },
  topBtnLayout: {
    alignItems: 'center',
  },
  topBtnBaseCss: {
    width: calcRemFn(187.5),
    height: calcRemFn(43)
  },
  bottomBtnLayout: {
    justifyContent: 'center',
  },
  bottomBtnBaseCss: {
    width: calcRemFn(107.5),
    height: calcRemFn(41)
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son4,
        img_actived: son4_active
      },
      {
        key: '_i2',
        show: true,
        img: son5,
        img_actived: son5_active
      },
      {
        key: '_i3',
        show: true,
        img: son6,
        img_actived: son6_active
      },

    ]
  }
}

const pictureList = [
  {
    key: '1_1',
    pid: 102863
  },
  {
    key: '1_2',
    pid: 102863,
    picNum: 1
  },
  {
    key: '1_3',
    pid: 102863,
    picNum: 1
  },
  {
    key: '2_1',
    pid: 102864
  },
  {
    key: '2_2',
    pid: 102864
  },
  {
    key: '2_3',
    pid: 102864
  }
]

function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum = 2, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/shopLabFeature/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

const topDiff = {
  firstSon: '_i1',
  top1_i1: 210,
  top1_i2: 20,
  top1_i3: -18,
  top2_i1: 135,
  top2_i2: 10,
}

export default {
  title: '功能照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
